import { useState } from 'preact/hooks';
import { getDisplayVersion, isDevelopmentBuild } from '@brainfocus/web/services/version';
import { getCurrentUser } from '@brainfocus/web/services/user';
import { WhatsNewModal } from './whats_new_modal';
import './version_footer.scss';

/**
 * Footer component displaying app version with link to changelog.
 *
 * Shows version in footer (e.g., "v0.5.0" or "v0.5.0-dev [DEV]").
 * Clicking opens the What's New modal with changelog.
 *
 * Only visible to super_admin users.
 */
export function VersionFooter() {
    const [showModal, setShowModal] = useState(false);
    const version = getDisplayVersion();
    const isDev = isDevelopmentBuild();
    const currentUser = getCurrentUser();
    const isSuperAdmin = currentUser?.role === 'super_admin';

    // Only super_admin sees the version footer
    if (!isSuperAdmin) {
        return null;
    }

    return (
        <>
            <footer class='bf-version-footer'>
                <button
                    class='bf-version-footer__link'
                    onClick={() => setShowModal(true)}
                    type='button'
                >
                    <span class='bf-version-footer__version'>BrainFocus v{version}</span>
                    {isDev && <span class='bf-version-footer__dev-badge'>DEV</span>}
                </button>
            </footer>
            {showModal && <WhatsNewModal onClose={() => setShowModal(false)} />}
        </>
    );
}
